import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SectionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Section",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.5 5.5h-21C3.57 5.5 2 7.07 2 9v14c0 1.93 1.57 3.5 3.5 3.5h21c1.93 0 3.5-1.57 3.5-3.5V9c0-1.93-1.57-3.5-3.5-3.5m0 3.5v5.25h-8.75V9zm-21 14V9h8.75v14zm12.25 0v-5.25h8.75V23z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43M3.29 7.14c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 27.71c-.63 0-1.14-.51-1.14-1.14V6A1.14 1.14 0 1 1 17 6v20.57c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.57 17.43H15.86a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};